import { sanitize } from './helpers'
export class GtmItem {
  constructor(gtmItem = {}) {
    this.templateName = gtmItem.templateName
    this.currency = gtmItem.currency
    this.shopUrl = gtmItem.shopUrl
  }

  get pageType() {
    switch (this.templateName) {
      case 'index':
        return 'homepage'
      case 'collection':
      case 'search':
      case 'product':
      case 'cart':
        return this.templateName
      default:
        return 'other'
    }
  }
}

export class GtmUser {
  constructor(gtmItem) {
    this.user_type = gtmItem.userType

    if (this.user_type === 'member') {
      this.user_id = gtmItem.userId
      this.user_r = gtmItem.userR
      this.user_f = gtmItem.userF
      this.user_m = gtmItem.userM
      this.user_eh = gtmItem.userEh
    }
  }
}

export class GtmCart {
  constructor(cart = {}) {
    this.id = cart.token
    this.totalPrice = cart.total_price / 100
    this.totalQuantity = cart.item_count
    this.itemArrays = new GtmCartItemArrays(cart.items)
    this.items = cart.items.map((item) => {
      return { ...new GtmCartItem(item) }
    })
  }

  get cartStatus() {
    return this.totalQuantity > 0
  }
}

class GtmCartItem {
  constructor(item = {}) {
    this.item_id = item.product_id.toString()
    this.name = sanitize(item.title)
    this.price = item.original_price * 0.01
    this.quantity = item.quantity
    this.item_url = item.url
    this.item_image_url = `https:${item.featured_image.url}`
  }
}

export class GtmCartArrayItem {
  constructor(item = {}) {
    this.name = item.title
    this.brand = item.vendor
    this.category = item.category
    this.categoryId = item.categoryId
    this.type = item.product_type
    this.sku = item.sku
    this.id = item.product_id.toString()
    this.imageUrl = `https:${item.featured_image.url}`
    this.variantId = item.variant_id.toString()
    this.variantTitle = item.variant_options[0]
    this.price = item.original_price * 0.01
    this.quantity = item.quantity
    this.url = item.url
    this.gProductId = getGProductId(item.product_id, item.variant_id)
  }
}

export class GtmCartItemArrays {
  constructor(items) {
    this.names = []
    this.brands = []
    this.categories = []
    this.categoryIds = []
    this.types = []
    this.skus = []
    this.imageUrls = []
    this.ids = []
    this.variantIds = []
    this.variantTitles = []
    this.prices = []
    this.urls = []
    this.quantities = []
    this.gProductIds = []

    items.forEach((i) => {
      const item = new GtmCartArrayItem(i)
      this.names.push(item.name)
      this.brands.push(item.brand)
      this.categories.push(item.category)
      this.categoryIds.push(item.categoryId)
      this.types.push(item.type)
      this.skus.push(item.sku)
      this.ids.push(item.id)
      this.imageUrls.push(item.imageUrl)
      this.variantIds.push(item.variantId)
      this.variantTitles.push(item.variantTitle)
      this.prices.push(item.price)
      this.urls.push(item.url)
      this.quantities.push(item.quantity)
      this.gProductIds.push(item.gProductId)
    })
  }
}

export class GtmCollection {
  constructor(gtmItem) {
    if (!gtmItem.collection) return
    const collection = JSON.parse(gtmItem.collection)
    const products = JSON.parse(gtmItem.collectionProducts || '[]')
    if (collection) {
      this.title = sanitize(collection.title)
      this.id = collection.id
      this.products = new GtmProducts(products)
    }
  }
}

export class GtmSearch {
  constructor(gtmItem) {
    this.term = gtmItem.searchTerm
    this.resultsCount = gtmItem.searchResultsCount
    this.resultsJson = gtmItem.resultsJson

    const products = JSON.parse(gtmItem.searchResults || '[]')
    this.products = new GtmProducts(products)
  }
}

export class GtmProducts {
  constructor(products) {
    this.vendors = products.map((product) => sanitize(product.vendor))
    this.types = products.map((product) => sanitize(product.type))
    this.skus = products.map((product) => sanitize(product.variants[0].sku))
    this.titles = products.map((product) => sanitize(product.title))
    this.ids = products.map((product) => product.id.toString())
    this.prices = products.map((product) =>
      (product.variants[0].price / 100).toFixed(1)
    )
    this.positions = new Array(products.length).fill(null).map((_, i) => i + 1)
    this.gProductIds = products.map((product) =>
      getGProductId(product.id, product.variants[0].id)
    )
    this.variantIds = products.map((product) =>
      product.variants[0].id.toString()
    )
  }
}

export class GtmProduct {
  constructor(gtmItem) {
    const product = JSON.parse(gtmItem.product || '{}')
    const variant = product.variants ? product.variants[0] : {}
    this.brand = sanitize(product.vendor)
    this.category = gtmItem.category
    this.featuredImageUrl = product.featured_image
      ? `https:${product.featured_image}`
      : null
    this.gProductId = getGProductId(product.id, variant.id)
    this.id = product.id
    this.itemUrl = `${gtmItem.shopUrl}${gtmItem.productUrl}`
    this.price = variant.price * 0.01
    this.sku = variant.sku
    this.title = sanitize(product.title)
    this.type = sanitize(product.type)
    this.variantId = variant.id
  }
}

export const getGProductId = (productId, variantId) => {
  return productId && variantId ? `Shopify_JP_${productId}_${variantId}` : ''
}
